import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Toast, { POSITION } from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import i18n from './locales/i18n'
createApp(App)

  .use(store)
  .use(router)
  .use(Toast, {
    transition: 'Vue-Toastification__bounce',
    maxToasts: 20,
    newestOnTop: true,
    position: POSITION.BOTTOM_CENTER,
    timeout: 4000,
    closeOnClick: true,
    closeButton: 'button'
  })
  .use(i18n)
  .mount('#app')
